import {
  type PimProductV11,
  PimProductV1LifestyleProductEnum,
} from '@redteclab/api/clients/bully'

export const productAccessorIsLifestyleProduct = (
  product: PimProductV11,
): boolean => {
  return (
    product.lifestyle_product ===
      PimProductV1LifestyleProductEnum.TrueWithExceptions ||
    product.lifestyle_product === PimProductV1LifestyleProductEnum.True
  )
}
